import React, { Component } from 'react';
import { Grid, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

export class Layout extends Component {
    displayName = Layout.name

    render() {
        return (

            <Grid>
                <Grid container>
                    <AppBar position="static">
                        <Toolbar variant="regular">
                            {/*<IconButton edge="start" color="inherit" aria-label="menu">
                            
                                <MenuIcon />
                            </IconButton> */}
                            <Typography variant="h5" color="inherit">
                                Projekte/DIGI
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Grid container justify="center">
                        {this.props.children}
                    </Grid>
                </Grid>
            </Grid>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js